// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3oMZP","inner":"Form_inner__5UI8W","range":"Form_range__3UqQC","name":"Form_name__Kve_6","actions":"Form_actions__3FoBg"};